/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id            = 'pageMain',
    Page          = require('stb-component-page'),
    app           = require('mag-app'),
    appConfig     = require('../config'),
    page          = new Page({$node: document.getElementById(id)}),
    PanelSet      = require('mag-component-panel-set'),
    PanelExtended = require('mag-component-panel'),
    LayoutList    = require('mag-component-layout-list'),
    ModalMessage  = require('mag-component-modal'),
    RadioList     = require('mag-component-radio-list'),
    dom           = require('spa-dom'),
    keys          = require('stb-keys'),
    tools         = require('../modules/tools'),
    Scroll        = require('stb-component-scrollbar'),
    fileSystem    = window.core.plugins.fs,
    pvr           = app.pvr,
    recordStates  = pvr.recordStates,
    Flicker       = require('spa-component-flicker'),
    Footer        = require('mag-component-footer'),
    ScrollArea    = require('mag-component-scroll-area'),
    pvrErrorCodes = {
        '-1': gettext('Wrong record parameters.'),
        '-2': gettext('Not enough memory.'),
        '-3': gettext('Wrong record range. Record lenth must be less than or equal 24 hours.'),
        '-4': gettext('Task with specified ID was not found.'),
        '-5': gettext('Wrong file name. Folder where you want to save recording must exist.'),
        '-6': gettext('Record with that name already exists.'),
        '-7': gettext('Error opening stream URL.'),
        '-8': gettext('Error opening file.'),
        '-9': gettext('Maximum number of simultaneous recording is exceeded.'),
        '-10': gettext('Records app got a thread exit notification. File record is over.'),
        '-11': gettext('Error writing file. Probably the disk is full or has been disconnected during recording.'),
        '-12': gettext('Wrong record url.'),
        '-13': gettext('Wrong file name.'),
        '-14': gettext('Wrong record start time.'),
        '-15': gettext('Wrong record end time.'),
        '-16': gettext('Bad record.')
    },
    stateToClass  = {},
    $channelsCountWrapper, $channelsCount, spvr, svrErrorCodes;


// define class name for each state
stateToClass[recordStates.WAITING] = 'theme-icon-clock theme-color-error';
stateToClass[recordStates.RECORDING] = 'theme-icon-play';
stateToClass[recordStates.ERROR] = 'theme-icon-warning theme-color-warning';
stateToClass[recordStates.FINISHED] = 'theme-icon-ok theme-color-success';


if ( MODE === 'MINISTRA' ) {
    // stalker have server pvr so we can use it
    spvr = app.spvr;
    svrErrorCodes = {
        '-1': gettext('Wrong channel id.'),
        '-2': gettext('Server error.'),
        '-3': gettext('Bad record.')
    };
    if ( window.core.plugins.tvBackend ) {
        // update channels
        window.core.plugins.tvBackend.updateChannelsList(function ( error ) {
            if ( error ) { console.log('channel list update error'); }
        });
    }
}

$channelsCountWrapper = dom.tag(
    'div',
    {className: 'amountContainer'},
    $channelsCount = dom.tag('div', {className: 'amount'}, '0')
);


app.storages = fileSystem.getMountPoints().concat(fileSystem.getHDDInfo());
app.records = [];

page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();

page.footer = new Footer({visible: false, parent: page});

fileSystem.onMount = function ( state ) {
    debug.log('onMount: ' + state);
    app.storages = fileSystem.getMountPoints().concat(fileSystem.getHDDInfo());
    if ( app.pages.add.active ) {
        if ( app.pages.add.modalSelectDevice.visible ) {
            app.pages.add.modalSelectDevice.hide();
        }
        app.pages.add.panelSet.reset();
        app.pages.add.panelSet.focus();
    }
};

page.playFocusedFile = function () {
    // focused file data
    var item = page.middlePanel.list.$focusItem.data.items[1].record;

    if ( item.data.state === item.states.FINISHED ) {
        if ( MODE === 'MINISTRA' && item.data.server ) {
            spvr.getFileUrl(item, function ( error, result ) {
                if ( error ) {
                    window.core.notify({title: svrErrorCodes[error.code], icon: 'alert', type: 'warning'});
                } else {
                    window.core.intent({
                        action: 'play',
                        mime: 'content/video',
                        data: {
                            uri: result.url,
                            title: item.data.name,
                            mediaId: result.mediaId
                        }
                    }, function ( error ) {
                        if ( error ) { window.core.notify({title: error.message, icon: 'alert', type: 'warning'}); }
                    });
                }
            });
        } else {
            window.core.intent({
                action: 'play',
                mime: 'content/video',
                data: {
                    uri: item.data.path,
                    title: item.data.name
                }
            }, function ( error ) {
                if ( error ) { window.core.notify({title: error.message, icon: 'alert', type: 'warning'}); }
            });
        }
        //     debug.log('send to play: ' + item.data.path);
    }
};
page.deleteFocusedTask = function () {
    var item;

    if ( page.middlePanel.list.$focusItem && page.middlePanel.list.$focusItem.data ) {
        item = page.middlePanel.list.$focusItem.data.items[1].record;
        if ( MODE === 'MINISTRA' && item.data.server ) {
            spvr.remove(item, function ( error ) {
                if ( error ) {
                    window.core.notify({title: svrErrorCodes[error.code], icon: 'alert', type: 'warning'});
                }
                page.modalActions.hide();
                page.middlePanel.focus();
                page.middlePanel.reset();
            });
        } else {
            pvr.remove(item, {deleteFile: false}, function ( recordItem, error ) {
                if ( error ) {
                    window.core.notify({title: pvrErrorCodes[error.code], icon: 'alert', type: 'warning'});
                }
                page.modalActions.hide();
                page.middlePanel.focus();
                page.middlePanel.reset();
            });
        }
    }
};
page.stopFocusedTask = function () {
    var item;

    if ( page.middlePanel.list.$focusItem && page.middlePanel.list.$focusItem.data ) {
        item = page.middlePanel.list.$focusItem.data.items[1].record;
        item.stop(item, function ( error ) {
            if ( error ) { window.core.notify({title: pvrErrorCodes[error.code], icon: 'alert', type: 'warning'}); }
        });
    }
};
page.downloadFocusedTask = function () {
    var item;

    if ( page.middlePanel.list.$focusItem && page.middlePanel.list.$focusItem.data ) {
        item = page.middlePanel.list.$focusItem.data.items[1].record;
        if ( MODE === 'MINISTRA' && item.data.state === item.states.FINISHED && item.data.server ) {
            spvr.getFileUrl(item, function ( error, result ) {
                if ( error ) {
                    window.core.notify({title: svrErrorCodes[error.code], icon: 'alert', type: 'warning'});
                } else {
                    // debug.info('send intent with data');
                    // debug.info(JSON.stringify({
                    //     action: 'download',
                    //     data: {uri: result.url, title: item.data.name}
                    // }));
                    window.core.intent({
                        action: 'download',
                        data: {uri: result.url, title: item.data.name}
                    }, function ( error ) {
                        if ( error ) { window.core.notify({title: error.message, icon: 'alert', type: 'warning'}); }
                    });
                }
            });
        }
        // debug.log('send to play: ' + item.data.path);
    }
};
page.resetFilters = function () {
    var $catChilds = page.leftPanel.list.$body.children[2].layout.$node.children;

    // reset search filter
    appConfig.list.filterSearch = '';
    page.leftPanel.search.innerText = gettext('Search');
    page.leftPanel.list.$body.children[1].children[0].children[0].classList.remove('active');

    // reset status filter and corresponding modal window
    if ( appConfig.list.filterStatus ) {
        appConfig.list.filterStatus = null;
        page.modalFilterStatus.children[0].resetData();
        $catChilds[1].innerText = gettext('All categories');
        $catChilds[0].classList.remove('active');
    }

    page.footer.hide();
    page.middlePanel.reset();
};

// modal message: reset all filters
page.modalReset = new ModalMessage({
    visible: false,
    title: gettext('actions'),
    events: {
        show: function () { this.focus(); },
        hide: function () { page.leftPanel.focus(); }
    },
    children: [
        new LayoutList({
            cycle: true,
            size: 1,
            data: [
                {
                    items: [
                        {className: 'theme-icon theme-icon-rc-f1', value: ''},
                        {value: gettext('Reset filters')}
                    ],
                    click: function () {
                        page.resetFilters();
                        page.modalReset.hide();
                        page.panelSet.focus();
                    }
                }
            ],
            propagate: true
        })
    ]
});
page.add(page.modalReset);

// modal message: do something with record
page.modalActions = new ModalMessage({
    visible: false,
    title: gettext('actions'),
    events: {
        show: function () {
            this.focus();
        },
        hide: function () {
            page.middlePanel.focus();
        }
    },
    children: [
        new LayoutList({
            cycle: true,
            data: [],
            propagate: true
        })
    ]
});
page.modalActions.fill = function ( data ) {
    // Timeout 1 of 2
    // Was added to fix visual artifacts during long and buggy dom rendering at mag322
    setTimeout(function () {
        var recordData = data.$item.data.items[1].record.data,
            record     = data.$item.data.items[1].record,
            body       = [
                {
                    items: [
                        {className: 'theme-icon', value: ''},
                        {value: gettext('Details')}
                    ],
                    click: function () {
                        page.modalActions.hide();
                        page.panelSet.blur();
                        app.route(app.pages.info, page.middlePanel.list.$focusItem);
                    }
                }, {
                    items: [
                        {className: 'theme-icon theme-icon-rc-f1', value: ''},
                        {value: gettext('Delete task')}
                    ],
                    click: page.deleteFocusedTask
                }
            ];

        // play finished record
        if ( recordData.state === record.states.FINISHED ) {
            body.unshift({
                items: [{className: 'theme-icon theme-icon-play', value: ''}, {value: gettext('Play file')}],
                click: function () {
                    page.modalActions.hide();
                    page.panelSet.focus();
                    page.playFocusedFile();
                }
            });
            if ( MODE === 'MINISTRA' && recordData.server && recordData.downloadable ) {
                body.unshift({
                    items: [{className: 'theme-icon', value: ''}, {value: gettext('Download file')}],
                    click: function () {
                        page.modalActions.hide();
                        page.panelSet.focus();
                        page.downloadFocusedTask();
                    }
                });
            }
        }
        // stop active record
        if ( recordData.state === record.states.RECORDING ) {
            body.unshift({
                items: [{className: 'theme-icon', value: ''}, {value: gettext('Stop recording')}],
                click: function () {
                    page.modalActions.hide();
                    page.panelSet.focus();
                    page.stopFocusedTask();
                }
            });
        }
        // add file deletion if local pvr
        if ( !recordData.server ) {
            body.push({
                items: [
                    {className: 'theme-icon', value: ''},
                    {value: gettext('Delete task and file')}
                ],
                click: function () {
                    var recordItem;

                    if ( page.middlePanel.list.$focusItem && page.middlePanel.list.$focusItem.data ) {
                        recordItem = page.middlePanel.list.$focusItem.data.items[1].record;
                        pvr.remove(recordItem, {deleteFile: true}, function ( sameRecordItem, error ) {
                            if ( error ) {
                                window.core.notify({
                                    title: pvrErrorCodes[error.code],
                                    icon: 'alert',
                                    type: 'warning'
                                });
                            }
                            page.modalActions.hide();
                            page.middlePanel.focus();
                            page.middlePanel.reset();
                        });
                    }
                }
            });
        }
        page.modalActions.children[0].init({data: body, size: body.length, focusIndex: 0});

        // Timeout 2 of 2
        // Was added to fix visual artifacts during long and buggy dom rendering at mag322
        setTimeout(function () {
            page.modalActions.show();
        }, 0);
    }, 0);
};
page.add(page.modalActions);


// modal message: filter by record status
page.modalFilterStatus = new ModalMessage({
    visible: false,
    title: gettext('categories'),
    events: {
        show: function () { this.focus(); },
        hide: function () { page.panelSet.focus(); }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            size: 5,
            data: [
                {state: true, title: gettext('All categories'), value: null},
                {state: false, title: gettext('Waiting'), value: 1},
                {state: false, title: gettext('In progress'), value: 2},
                {state: false, title: gettext('Error'), value: 3},
                {state: false, title: gettext('Completed'), value: 4}
            ],
            events: {
                'click:item': function ( event ) {
                    var $item = page.leftPanel.list.$body.children[2].children[0];

                    if ( event.$item.data.value ) {
                        $item.children[0].classList.add('active');
                    } else {
                        $item.children[0].classList.remove('active');
                    }
                    $item.children[1].innerText = event.$item.data.title;
                    appConfig.list.filterStatus = event.$item.data.value;
                    page.middlePanel.reset();
                    page.modalFilterStatus.hide();
                }
            },
            propagate: true
        })
    ]
});
page.add(page.modalFilterStatus);

// modal message: sort
page.modalSort = new ModalMessage({
    visible: false,
    title: gettext('sort'),
    events: {
        show: function () { this.focus(); },
        hide: function () { page.panelSet.focus(); }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            size: 3,
            data: [
                {state: true, title: gettext('By name'), value: 0},
                {state: false, title: gettext('By category'), value: 1},
                {state: false, title: gettext('By date'), value: 2}
            ],
            events: {
                'click:item': function ( event ) {
                    page.leftPanel.list.$focusItem.layout.$node.children[1].innerText = event.$item.data.title;
                    appConfig.list.sort = event.$item.data.value;
                    page.middlePanel.reset();
                    page.modalSort.hide();
                }
            },
            propagate: true
        })
    ]
});
page.add(page.modalSort);

// modal message: exit
page.modalExit = new ModalMessage({
    title: gettext('Exit'),
    className: 'modalExit',
    events: {
        show: function () { this.children[0].focus(); },
        hide: function () { page.panelSet.focus(); }
    },
    children: [
        new LayoutList({
            size: 2,
            focusIndex: 0,
            data: [
                {
                    items: [{value: gettext('Yes')}],
                    click: function () {
                        page.modalExit.hide();
                        app.exit();
                    }
                },
                {
                    items: [{value: gettext('No')}],
                    click: function () { page.modalExit.hide(); }
                }
            ],
            propagate: true
        })
    ]
});
page.add(page.modalExit);

// left panel (menu)
page.leftPanel = new PanelExtended({title: gettext('Menu'), children: [], className: 'leftPanel'});
page.leftPanel.add(page.leftPanel.list = new LayoutList({
    cycle: true,
    focusIndex: 0,
    size: 5,
    data: [
        {
            items: [{className: 'theme-icon theme-icon-plus', value: ''}, {value: gettext('Create')}],
            click: function () {
                page.panelSet.blur();
                app.route(app.pages.add);
            }
        },
        {
            items: [
                {className: 'theme-icon theme-icon-search', value: ''},
                page.leftPanel.search = dom.tag('div', {className: 'searchText'}, gettext('Search'))
            ],
            click: function () {
                var inputText = page.leftPanel.search.innerText;

                window.core.intent({
                    action: 'keyboard',
                    data: {
                        type: 'text',
                        mode: 'qwerty',
                        title: gettext('SEARCH RECORDS'),
                        description: gettext('RECORDS'),
                        value: inputText === gettext('Search') ? '' : inputText
                    },
                    events: {
                        done: function ( event ) {
                            var $icon = page.leftPanel.list.$body.children[1].children[0].children[0];

                            if ( event.value ) {
                                $icon.classList.add('active');
                            } else {
                                $icon.classList.remove('active');
                            }
                            page.leftPanel.search.innerText = event.value || gettext('Search');
                            appConfig.list.filterSearch = event.value;
                            page.middlePanel.reset();
                        }
                    }
                }, function ( error ) {
                    console.log(error);
                });
            }
        },
        {
            items: [
                {className: 'theme-icon theme-icon-categories', value: ''},
                {className: 'theme-item-more', value: gettext('All categories')}
            ],
            click: function () {
                page.panelSet.blur();
                page.modalFilterStatus.show();
            }
        },
        {
            items: [
                {className: 'theme-icon theme-icon-sort-az', value: ''},
                {className: 'theme-item-more', value: gettext('By name')}
            ],
            click: function () {
                page.panelSet.blur();
                page.modalSort.show();
            }
        },
        {
            items: [{className: 'theme-icon theme-icon-exit', value: ''}, {value: gettext('Exit')}],
            click: function () {
                page.panelSet.blur();
                page.modalExit.show();
            }
        }
    ],
    events: {
        'focus:item': function () {
            if ( appConfig.list.filterSearch || appConfig.list.filterStatus ) {
                page.footer.init({
                    middle: [{code: keys.f1, title: gettext('Reset filters'), action: page.resetFilters}],
                    left: {
                        code: keys.menu,
                        action: function () {
                            page.panelSet.blur();
                            page.modalReset.show();
                        }
                    }
                });
                page.footer.show();
            } else {
                page.footer.hide();
            }
        },
        focus: function () {
            if ( appConfig.list.filterSearch || appConfig.list.filterStatus ) {
                page.footer.init({
                    middle: [{code: keys.f1, title: gettext('Reset filters'), action: page.resetFilters}],
                    left: {
                        code: keys.menu,
                        action: function () {
                            page.panelSet.blur();
                            page.modalReset.show();
                        }
                    }
                });
                page.footer.show();
            } else {
                page.footer.hide();
            }
        },
        blur: function () {
            page.footer.hide();
        }
    }
}));


// middle panel (records list)
page.middlePanel = new PanelExtended({
    title: [{value: gettext('Records'), className: 'name'}, $channelsCountWrapper],
    main: true,
    children: [],
    className: 'middlePanel'
});
// delay between buttons press and refreshing action menu and right panel
page.middlePanel.updateDelay = null;
page.middlePanel.scroll = new Scroll({});
page.middlePanel.add(page.middlePanel.list = new LayoutList({
    cycle: true,
    focusIndex: 0,
    size: 7,
    data: [],
    scroll: page.middlePanel.scroll,
    events: {
        'focus:item': function ( data ) {
            var body;

            // cancel previous update
            clearTimeout(page.middlePanel.updateDelay);
            page.middlePanel.updateDelay = setTimeout(function () {
                var current;

                if ( data ) {
                    body = {
                        middle: [{code: keys.f1, title: gettext('Delete task'), action: page.deleteFocusedTask}],
                        left: {
                            code: keys.menu,
                            action: function () {
                                // redefine menu to fix first item delayed add
                                page.panelSet.blur();
                                page.modalActions.fill({$item: page.middlePanel.list.$focusItem});
                            }
                        }
                    };
                    page.rightPanel.reset(data);

                    if ( page.middlePanel.list.$focusItem ) {
                        current = page.middlePanel.list.$focusItem.data.items[1].record;
                        if ( current.data.state === current.states.FINISHED ) {
                            // playable file
                            body.middle.push({
                                code: keys.f2,
                                title: gettext('Play file'),
                                action: page.playFocusedFile
                            });
                        }
                    }
                    if ( page.activeComponent === page.middlePanel.list ) {
                        page.footer.init(body);
                        page.footer.show();
                    }
                } else if ( page.activeComponent === page.middlePanel.list ) {
                    // bad item, hide footer
                    page.footer.hide();
                }
            }, window.core.environment.onFocusDebounceTimeout);
        },
        focus: function () {
            // show footer if list have at least one item
            var body = {
                    middle: [{code: keys.f1, title: gettext('Delete task'), action: page.deleteFocusedTask}],
                    left: {
                        code: keys.menu,
                        action: function () {
                            page.panelSet.blur();
                            page.modalActions.fill({$item: page.middlePanel.list.$focusItem});
                        }
                    }
                },
                current;

            if ( page.middlePanel.list.$focusItem ) {
                current = page.middlePanel.list.$focusItem.data.items[1].record;
                if ( current.data.state === current.states.FINISHED ) {
                    // playable file
                    body.middle.push({code: keys.f2, title: gettext('Play file'), action: page.playFocusedFile});
                }
                page.footer.init(body);
                page.footer.show();
            } else {
                page.footer.hide();
            }
        },
        blur: function () {
            page.footer.hide();
        }
    },
    noData: dom.tag(
        'div',
        {className: 'panelHint'},
        dom.tag(
            'div',
            {className: 'hint'},
            dom.tag('div', {className: 'hint', innerHTML: gettext('No records')})
        )
    )
}), page.middlePanel.scroll);


function refreshMiddleList () {
    var newData = [],
        // predefined items order for sort by state in records list
        states  = {
            0: recordStates.ERROR,
            1: recordStates.RECORDING,
            2: recordStates.WAITING,
            3: recordStates.FINISHED
        },
        records = app.records.slice(),
        list    = page.middlePanel.list,
        body, index, storageIndex;

    function itemClick () {
        if ( page.middlePanel.list.$focusItem ) {
            page.panelSet.blur();
            page.modalActions.fill({$item: page.middlePanel.list.$focusItem});
        }
    }

    for ( index = 0; index < records.length; index++ ) {
        // check if it correspond to status filter
        if ( !(appConfig.list.filterStatus !== null && records[index].data.state !== appConfig.list.filterStatus) &&
            // check if it correspond to search filter
            !(appConfig.list.filterSearch.trim() && records[index].data.name.indexOf(appConfig.list.filterSearch) === -1 &&
                records[index].data.url.indexOf(appConfig.list.filterSearch) === -1) ) {
            // add info about storage
            if ( MODE === 'MINISTRA' && records[index].data.server ) {
                records[index].data.storage = {
                    freeSize: 0,
                    fsType: 0,
                    isReadOnly: 0,
                    label: gettext('Server'),
                    mediaType: 2,
                    model: '',
                    mountPath: '',
                    partitionNum: 0,
                    size: 0,
                    sn: '',
                    vendor: ''
                };
            } else {
                for ( storageIndex = 0; storageIndex < app.storages.length; storageIndex++ ) {
                    if ( records[index].data.path.indexOf(app.storages[storageIndex].mountPath) !== -1 ) {
                        records[index].data.storage = app.storages[storageIndex];
                        break;
                    }
                }
            }

            newData.push({
                items: [
                    {
                        className: 'theme-icon ' + stateToClass[Number(records[index].data.state)],
                        value: ''
                    },
                    {
                        value: records[index].data.progress + '% ' + records[index].data.name,
                        className: 'title',
                        record: app.records[index]
                    }
                ],
                click: itemClick
            });
        }
    }

    // sort it
    if ( !appConfig.list.sort ) {
        // by name
        newData.sort(function ( first, next ) {
            return first.items[1].record.data.name.toLowerCase().localeCompare(next.items[1].record.data.name.toLowerCase());
        });
    } else if ( appConfig.list.sort === appConfig.constants.sort.BY_CATEGORY ) {
        // by category
        newData.sort(function ( first, next ) {
            return states[first.items[1].record.data.state] - states[next.items[1].record.data.state];
        });
    } else {
        // by date
        newData.sort(function ( first, next ) {
            return next.items[1].record.data.startTime - first.items[1].record.data.startTime;
        });
    }

    body = {data: newData};
    $channelsCount.innerText = newData.length;
    if ( newData.length ) {
        body.focusIndex = list.$focusItem && list.$focusItem.index < newData.length ? list.$focusItem.index : 0;
        page.middlePanel.scroll.init({realSize: newData.length, viewSize: 7});
        page.middlePanel.scroll.show();
    } else {
        page.rightPanel.reset();
        if ( page.activeComponent === page.middlePanel.list ) { page.footer.hide(); }
        page.middlePanel.scroll.hide();
    }
    list.init(body);
}


page.middlePanel.resetTimeOut = null;
page.middlePanel.reset = function () {
    // prevent reset call spam
    clearTimeout(page.middlePanel.resetTimeOut);
    page.middlePanel.resetTimeOut = setTimeout(refreshMiddleList, 300);
};

// right panel (record information)
page.rightPanel = new PanelExtended({title: gettext('Details'), className: 'rightPanel'});
page.rightPanel.scroll = new Scroll({});
page.rightPanel.textArea = new ScrollArea({propagate: true, step: 5, scroll: page.rightPanel.scroll});
page.rightPanel.add(page.rightPanel.textArea, page.rightPanel.scroll);
page.rightPanel.reset = function ( data ) {
    var area = page.rightPanel.textArea,
        item, date, dur;

    if ( !area.$channel ) {
        area.$body.appendChild(dom.fragment(
            dom.tag('div', {className: 'title theme-subhead-color'}, gettext('Channel:')),
            area.$channel = dom.tag('div', {}),
            dom.tag('div', {className: 'title theme-subhead-color'}, gettext('Record name:')),
            area.$name = dom.tag('div', {}),
            dom.tag('div', {className: 'title theme-subhead-color'}, gettext('Record start:')),
            area.$date = dom.tag('div', {}),
            dom.tag('div', {className: 'title theme-subhead-color'}, gettext('Record length:')),
            area.$time = dom.tag('div', {}),
            dom.tag('div', {className: 'title theme-subhead-color'}, gettext('Storage:')),
            area.$storage = dom.tag('div', {}),
            dom.tag('div', {className: 'title theme-subhead-color'}, gettext('Status:')),
            area.$state = dom.tag('div', {})
        ));
    }
    if ( data && data.$curr && data.$curr.data ) {
        item = data.$curr.data.items[1].record.data;
        date = tools.parseDate(new Date(item.startTime * 1000));
        dur = {
            hours: Math.floor((item.endTime - item.startTime) / 3600),
            minute: Math.ceil((item.endTime - item.startTime) / 60 % 60)
        };
        area.$channel.innerText = item.channel;
        area.$name.innerText = item.name;
        area.$date.innerText = date;
        if ( dur.hours ) {
            area.$time.innerText = dur.hours + ' ' + gettext('h.') + ' ' + dur.minute + ' ' + gettext('m.');
        } else {
            area.$time.innerText = dur.minute + ' ' + gettext('m.');
        }
        area.$storage.innerText = item.storage ? item.storage.label : gettext('Not connected');
        area.$state.innerText = ['', gettext('Waiting'), gettext('Running'), gettext('Error'), gettext('Completed')][Number(item.state)];
        if ( Number(item.state) === 3 && !item.server && pvrErrorCodes[item.errorCode] ) {
            // local pvr have error text
            area.$state.innerText += ': ' + pvrErrorCodes[item.errorCode];
        }
        page.rightPanel.textArea.show();
        page.rightPanel.textArea.init();
    } else {
        page.rightPanel.textArea.hide();
    }
};


// panel set: main
page.panelSet = new PanelSet({
    visible: true,
    $node: document.getElementById('panelSetMain'),
    panels: [page.leftPanel, page.middlePanel, page.rightPanel]
});
// panelSet constructor cant handle focus by himself
page.panelSet.focusIndex = 1;
page.add(page.panelSet);


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            page.panelSet.blur();
            window.core.call('stop');
            break;
    }
});

// server video recorder events
if ( MODE === 'MINISTRA' ) {
    // reset all event listeners
    spvr.events = {};
    spvr.addListeners({
        add: function ( config ) {
            app.records.push(config.item);
            page.middlePanel.reset();
        },
        remove: function ( config ) {
            app.records.splice(app.records.indexOf(config.item), 1);
            page.middlePanel.reset();
        },
        progress: function () {
            page.middlePanel.reset();
        },
        state: function () {
            page.middlePanel.reset();
        }
    });
    spvr.reset();
}

// local (personal) video recorder events
// reset all event listeners
pvr.events = {};
pvr.addListeners({
    add: function ( config ) {
        if ( config.item.data.state === config.item.states.ERROR ) {
            window.core.notify({
                title: gettext('Error') + (pvrErrorCodes[config.item.data.errorCode] ? ': ' + pvrErrorCodes[config.item.data.errorCode] : ''),
                icon: 'alert',
                type: 'warning'
            });
        }

        config.item.addListeners({
            progress: function () {
                page.middlePanel.reset();
            },
            state: function ( data ) {
                if ( data.curr === data.item.states.ERROR ) {
                    window.core.notify({
                        title: gettext('Error') + (pvrErrorCodes[data.item.data.errorCode] ? ': ' + pvrErrorCodes[data.item.data.errorCode] : ''),
                        icon: 'alert',
                        type: 'warning'
                    });
                }
                page.middlePanel.reset();
            }
        });

        app.records.push(config.item);

        page.middlePanel.reset();
    },
    remove: function ( config ) {
        app.records.splice(app.records.indexOf(config.item), 1);
        page.middlePanel.reset();
    }
});

// restore records added before this app have had been launched
pvr.list.forEach(function ( item ) {
    app.records.push(item);
});
// reset to apply added items
page.middlePanel.reset();

// window.core.intent({action:'record',data:{uri:'rtp://239.1.1.1:1234',name:'video',id:14,pvr:{local:true, server:true},
// startTime:Math.ceil((new Date).getTime()/1000),endTime:Math.ceil((new Date).getTime()/1000+60)}},function(){});
window.core.addListener('intent', function ( intent, callback ) {
    if ( intent.action === 'record' ) {
        app.intent = intent;
        app.route(app.pages.add);
        app.pages.add.reset();
        callback(false, {});
    }
});

page.addListener('show', function () {
    page.panelSet.show();
    page.panelSet.focus();
});

window.core.addListeners({
    show: function () { page.clock.start(); },
    hide: function () { page.clock.stop(); },
    exit: function () {
        pvr.destroy();
        if ( MODE === 'MINISTRA' ) {
            spvr.destroy();
        }
    }
});

app.route(page);
page.show();

// public
module.exports = page;
